import { useAddTimeCard as useAddTimeCardBase } from '@features/time-logging/hooks/useTimeCardManagement'
import { useDateTimeWithLocale } from '@hooks/useDateTimeWithLocale'
import { toast } from 'lib/toasts'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

interface UseAddTimeCardOptions {
  date: DateTime
  start: DateTime
  end: DateTime
}

export const useAddTimeCard = ({ date, start, end }: UseAddTimeCardOptions) => {
  const { t } = useTranslation()
  const withLocale = useDateTimeWithLocale()

  const { mutate, ...rest } = useAddTimeCardBase(
    { start, end },
    {
      onSuccess: () => {
        toast({
          title: t('features.timeLogging.timeCardCreated'),
          content: t('features.timeLogging.timeCardSuccessfullyCreated', {
            date: withLocale(date).toLocaleString({ weekday: 'long' }),
          }),
          variant: 'default',
        })
      },
      onError: () => {
        toast({
          title: t('features.timeLogging.errorCreatingTimeCard'),
          content: t('features.timeLogging.timeCardCouldNotBeCreated'),
          variant: 'error',
        })
      },
    },
  )

  return useMemo(
    () => ({ ...rest, mutate: () => mutate(date) }),
    [mutate, rest, date],
  )
}
